import { createSelector } from 'reselect';

// Config
import { getDeliveriesSelector, getSelectedDeliveryChoiceIdSelector } from '@redux/reducers/delivery/deliverySelector';
import { getGrandTotalRawSelector } from '@redux/reducers/order-form/orderFormSelector';
import { isDeliveryThresholdIncreaseFeatureActive } from '@redux/reducers/config/configSelector';
import { isOneMan } from '@utils/delivery/deliveryHelper';

const deliveryChoiceTabsState = createSelector(
  [
    getGrandTotalRawSelector,
    getSelectedDeliveryChoiceIdSelector,
    isDeliveryThresholdIncreaseFeatureActive,
    getDeliveriesSelector,
  ],
  (
    grandTotalRaw,
    selectedDeliveryChoiceId,
    isDeliveryThresholdIncreaseFeatureActive,
    deliveries,
  ) =>
  {
    const isEligibleForDeliveryThresholdIncrease =
      (
        isDeliveryThresholdIncreaseFeatureActive &&
        deliveries &&
        deliveries.length > 0 &&
        isOneMan(deliveries[0].type)
      ) ?? false;

    return {
      grandTotalRaw,
      selectedDeliveryChoiceId,
      isDeliveryThresholdIncreaseEnabled: isEligibleForDeliveryThresholdIncrease,
    };
  },
);

export default deliveryChoiceTabsState;
